import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class UserSettingApi {
  getTwoFactorSettings(userId,  config) {
    return axios.get(`${BASE_URL}/admin/userSetting/twoFactorAuth/${userId}`, config)
  }

  updateTwoFactorSettings( userId,  data, config) {
    return axios.put(`${BASE_URL}/admin/userSetting/updateTwoFactorAuth/${userId}`, data, config)
  }

  updateUserSettings(userId, data, config) {
    return axios.put(`${BASE_URL}/admin/userSetting/updateUserSettings/${userId}`, data, config)
  }
  fetchUserSettings(userId, config) {
    return axios.get(`${BASE_URL}/admin/userSetting/fetchUserSettings/${userId}`, config)
  }
 
  
  
}

const userSettingApi = new UserSettingApi()
export default userSettingApi
